import { QRCodeCanvas } from "qrcode.react";
import { useRef } from "react";

// Renders an off-screen QR canvas and downloads it as a PNG on demand, so a
// QR code can be saved without first opening the QR preview modal.
export const useDownloadQrCode = (
  url: string,
  fileName = "referral-qr-code.png",
) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  const downloadQrCode = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const link = document.createElement("a");
    link.download = fileName;
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  const hiddenQrCode = (
    <QRCodeCanvas
      ref={canvasRef}
      value={url}
      size={200}
      level="M"
      marginSize={4}
      aria-hidden
      className="hidden"
    />
  );

  return { hiddenQrCode, downloadQrCode };
};
